import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.geo-raster-image-aws-uploader', () => {
  import('./internal/geo-raster-image-aws-uploader').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.ndvi-function', () => {
  import('./internal/ndvi-function').then(({ default: Component }) => Component());
});
